import create from 'zustand';
export var useShellUtilitiesStore = create(function (set) { return ({
    rendered: undefined,
    loaded: undefined,
    error: undefined,
    setRendered: function (rendered) {
        set({ rendered: rendered });
    },
    setError: function (error) {
        set({ error: error });
    },
    setLoaded: function (loaded) {
        set({ loaded: loaded });
    },
}); });
export var ShellStoreActions = {
    setLoaded: function (loaded) {
        useShellUtilitiesStore.getState().setLoaded(loaded);
    },
    setError: function (error) {
        useShellUtilitiesStore.getState().setError(error);
    },
    setRendered: function (loaded) {
        useShellUtilitiesStore.getState().setRendered(loaded);
    },
};
//# sourceMappingURL=store.js.map